import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// The BE returns errors (e.g. review-not-found 409) as a CDM { success, error }
// JSON body delivered as a blob, since the success path is a PDF blob.
const parseBlobError = async (data) => {
  if (!(data instanceof Blob)) return data;

  try {
    return JSON.parse(await data.text());
  } catch {
    return null;
  }
};

const downloadCarePlanPdfFn = async ({ reviewId, tenantVal }) => {
  const axiosInstance = createAxiosInstance();
  const response = await axiosInstance.get(
    `${tenantVal}/cdm/reviews/${reviewId}/care-plan/pdf`,
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `care-plan-${reviewId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const handleDownloadError = async (error) => {
  const body = await parseBlobError(error?.response?.data);
  toast.error(body?.error || "Failed to download care plan");
};

export const useDownloadCarePlanPdf = () =>
  useMutation({
    mutationFn: downloadCarePlanPdfFn,
    meta: { skipGlobalError: true },
    onError: handleDownloadError,
  });
